export const environment = {
  production: true,
  tag: 'dev',
  apiUrl: 'https://gw.dev.watchtower.boemm.eu/v1/watchtower/api',
  auth: {
    loginPage:
      'https://watchtower-auth-ad.auth.eu-central-1.amazoncognito.com/login?client_id=70lruro4abp9225ue3i43kb089&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https%3A%2F%2Fgw.dev.watchtower.boemm.eu%2Fv1%2Fsignin',
  },
};
